import { render, staticRenderFns } from "./Voip.vue?vue&type=template&id=bbc6491e&scoped=true"
import script from "./Voip.vue?vue&type=script&lang=js"
export * from "./Voip.vue?vue&type=script&lang=js"
import style0 from "./Voip.vue?vue&type=style&index=0&id=bbc6491e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc6491e",
  null
  
)

export default component.exports